// @flow
import { MANAGE_ALERTS_CTA_PATH, MANAGE_ALERTS_CTA_TRACKING_PARAMETERS } from './constants';

export const createNotificationsManagerUrl = (
  domain: ?string,
  verticalPath: ?string,
  userControlToken: ?string,
  email: ?string
): ?string => {
  if (!domain || !userControlToken || !email) {
    return null;
  }

  const path = verticalPath || '';

  return `https://${domain}${path}/${MANAGE_ALERTS_CTA_PATH}/act.${userControlToken}/email.${email}/?${MANAGE_ALERTS_CTA_TRACKING_PARAMETERS}`;
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/CallToActionLink/utils.js